<script setup lang="ts">
/**
 * One icon of `icons.ts` in the colour of the text around it: the tinted area at 20 %, the
 * outline in full. Decorative, hidden from assistive technology; the text beside it says what it
 * means. The size comes from the app's classes (`size-4`).
 */
import type { DuotoneIconPaths } from "./icons.ts";

const props = defineProps<{ icon: DuotoneIconPaths }>();
</script>

<template>
  <svg viewBox="0 0 256 256" fill="currentColor" aria-hidden="true">
    <path :d="props.icon.tint" opacity="0.2" />
    <path :d="props.icon.shape" />
  </svg>
</template>
